import Marquee from "react-fast-marquee";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  return (
    <section
      className="relative bg-[var(--pam-forest)] text-white overflow-hidden"
      style={{ padding: "5% 0" }}
      data-testid="testimonials-section"
    >
      <div className="container-pam text-center mb-14">
        <p className="overline text-[var(--pam-gold)]">Guest notes</p>
        <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-3xl mx-auto">
          The nicest things,
          <span className="italic text-[var(--pam-gold)]">
            {" "}unhurriedly said.
          </span>
        </h2>
      </div>

      <div className="marquee-fade">
        <Marquee gradient={false} speed={35} pauseOnHover>
          {TESTIMONIALS.map((t, i) => (
            <article
              key={i}
              className="mx-4 my-2 w-[320px] sm:w-[400px] shrink-0 bg-white/[0.04] border border-white/10 backdrop-blur-md rounded-sm p-7"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-6 h-6 text-[var(--pam-gold)]" />
              <p className="mt-4 font-serif text-lg md:text-xl leading-relaxed text-white/90">
                “{t.text}”
              </p>
              <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between text-sm">
                <span className="tracking-wide">{t.name}</span>
                <span className="text-white/50 uppercase text-xs tracking-[0.2em]">
                  {t.from}
                </span>
              </div>
            </article>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
